import styled from '@emotion/styled/macro'

export const ProfileAvatar = styled.img`
  border-radius: 999999px;
  margin: 0 5%;
`

export const Avatar = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.primary};
  border: 5px solid white;
  border-radius: 50px;
  box-shadow: 0 0 4px ${({ theme }) => theme.colors.typography[0]};
  color: white;
  display: flex;
  justify-content: center;
  padding: 6px;
  text-align: center;
  width: 50px;
`
